const customerCenterMenuPane = document.getElementById('customer-center-menu-mini-modal')
const customerCenterMenuItem = document.querySelector('.menu-item.customer-center-menu-toggle-on')
const customerCenterMenuItemLink = document.querySelector('.menu-item.customer-center-menu-toggle-on > a')
if( customerCenterMenuPane && customerCenterMenuItem ){
	customerCenterMenuItem.append(customerCenterMenuPane);
	customerCenterMenuItemLink.addEventListener( 'click', e => {
		e.preventDefault();
		customerCenterMenuPane.style.display = 'flex';
	})
	const closeButton = customerCenterMenuPane.querySelector('.customer-center-menu-toggle-off')
	closeButton.addEventListener( 'click', e => {
		e.preventDefault();
		e.stopPropagation();
		customerCenterMenuPane.style.display = 'none';

	})
}
document.addEventListener( 'click', e => {
	const clickIsInside = customerCenterMenuItem.contains(e.target);
	if( ! clickIsInside ){
		customerCenterMenuPane.style.display = 'none';
	}
})
